import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    instructions: {
        '& li': {
            marginTop: '5px',
        }
    }
}));

export default () => {
    const classes = useStyles();

    return (
        <Card>
            <CardContent>
                <h3>Instructions:</h3>
                <ol className={classes.instructions}>
                    <li>Maximum of 10,000 records are allowed per file.</li>
                    <li>Only one file will be processed at once, others will be queued.</li>
                </ol>
            </CardContent>
        </Card>
    );
};

